import { motion } from "framer-motion";

// Monogram mark (italic "c" + bold "f"), echoing the Culifect wordmark.
export const LogoMark = ({ className = "h-9 w-9", draw = false }) => (
  <motion.svg
    viewBox="0 0 64 64"
    className={className}
    aria-hidden="true"
    initial={draw ? { scale: 0.6, opacity: 0, rotate: -8 } : false}
    animate={{ scale: 1, opacity: 1, rotate: 0 }}
    transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
  >
    <rect width="64" height="64" rx="14" fill="#141412" stroke="#C59B27" strokeOpacity="0.35" />
    <text x="5" y="45" fontFamily="Playfair Display, Georgia, serif" fontStyle="italic" fontSize="38" fill="#FAF8F5">c</text>
    <text x="29" y="45" fontFamily="Plus Jakarta Sans, Arial, sans-serif" fontWeight="800" fontSize="38" fill="#FAF8F5">f</text>
    <motion.rect
      x="12" y="51" height="3" rx="1.5" fill="#C59B27"
      initial={draw ? { width: 0 } : false}
      animate={{ width: 40 }}
      transition={{ duration: 0.8, delay: draw ? 0.5 : 0 }}
    />
  </motion.svg>
);

export const Logo = ({ light = true, className = "h-9 sm:h-10" }) => (
  <img
    src={light ? "/images/culifect_logo_light.png" : "/images/culifect_logo_dark.png"}
    alt="Culifect Catering"
    className={`${className} w-auto select-none`}
    draggable={false}
  />
);
